import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const HamburgerMenuIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M3.75 12.5H20.25"
        stroke={color ?? token.colorText}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 6.5H20.25"
        stroke={color ?? token.colorText}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 18.5H20.25"
        stroke={color ?? token.colorText}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HamburgerMenuIcon;
